import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

export const NoResultsStyles = css`
  .no-result {
    background-color: ${colors.gray.shade6};
    padding: 11px 0 100px 0;
    float: left;
    width: 100%;
    margin-top: -2px;
    display: flex;
    flex-direction: column;
  }

  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: ${colors.white.shade1};
  }

  @media (min-width: 1024px) {
    .image-container {
      height: 440px;
    }
  }

  .recommended-products-container {
    margin-top: 23px;

    &:empty {
      display: none;
    }
  }
`;
